import i18n from "@/i18n";
import type { PlannedWorkout } from "@/types";
import { SPORT_LABELS } from "@/lib/tss";

const TYPE_KEYS: Record<string, string> = {
  endurance: "endurance", aerobic: "endurance", easy: "easy", recovery: "recovery",
  technique: "technique", threshold: "threshold", sub_threshold: "sub_threshold",
  sweet_spot: "sweet_spot", tempo: "tempo", vo2: "vo2", vo2max: "vo2",
  long: "long", long_z2: "long", race_pace: "race_pace", brick_race_pace: "race_pace",
  brick: "brick", walk_run: "walk_run", strength: "strength", mobility: "mobility",
  race_simulation: "simulation", race_rehearsal: "simulation", test: "test",
  openers: "activation", rest: "rest",
};
export function workoutTypeLabel(type: string): string {
  return i18n.t(`workout_types.${TYPE_KEYS[type] ?? "session"}`);
}

// Only exact application template titles are translated. Athlete notes and
// authored detailed titles remain verbatim, including English custom titles.
const LEGACY_PREVIEW_TITLES = new Set([
  "Bike Z2 + Strength (lighter)",
  "Bike Z2 + Strength 1 (compound)",
  "Bike Z2 + short Strength",
  "Bike easy spin",
  "Bike openers (easy + 2x 3min race pace)",
  "Bike openers + Z2 (medium)",
  "Bike openers + easy Z2",
  "Bike race-pace intervals",
  "Bike sub-threshold intervals",
  "Bike sweet spot + Strength (compound)",
  "Bike threshold (short)",
  "Bike threshold + openers",
  "Easy swim technique",
  "Long Bike + Run off (brick, race pace)",
  "Long Bike + Strength 2 (compound)",
  "Long Bike Z2 + Strength 2 (compound)",
  "Long Bike Z2-Z3 + Strength (compound)",
  "Race rehearsal brick (full kit)",
  "Race simulation brick (peak volume)",
  "Run Z2 aerobic base",
  "Run easy Z1-Z2",
  "Run easy recovery",
  "Run openers (easy + 3x 1min race pace)",
  "Run race-pace + form drills",
  "Run race-pace 5K reps",
  "Run race-pace reps",
  "Run tempo intervals",
  "Run threshold intervals",
  "Swim aerobic endurance",
  "Swim easy technique",
  "Swim long aerobic",
  "Swim openers (short)",
  "Swim race-pace sets",
  "Swim race-pace sharp",
  "Swim race-pace sharpening",
  "Swim race-pace volume",
  "Swim recovery technique",
  "Swim technique + aerobic (base)",
  "Swim technique + aerobic (база)",
  "Swim technique + aerobic base",
  "Swim threshold intervals",
  "Swim threshold sets (CSS)",
  "Swim very easy recovery",
  "Walk-run Z1-Z2"
]);
export function plannedWorkoutTitle(workout: PlannedWorkout): string {
  if (workout.status !== "skeleton" || !LEGACY_PREVIEW_TITLES.has(workout.title)) return workout.title;
  const sports = [SPORT_LABELS[workout.sport] ?? workout.sport];
  if (workout.session_blocks?.some(block => block.block === "strength") && workout.sport !== "strength") sports.push(SPORT_LABELS.strength);
  return `${sports.join(" + ")} · ${workoutTypeLabel(workout.type)}`;
}
